export class IssuesModel {
  JournalList: JSON;
  issueList: JSON;
  volumeList: JSON;
  YearList: JSON;
  VolumeIssueList: JSON;
  ProjectPlanList: JSON;
  ApprovedArticleList: JSON;
  ArticleColumnList: JSON;
  IssueConfig: JSON;
  IssueTypeList: JSON;

  ElementsList: JSON;
  FromMatterList: JSON;
  BackMatterList: JSON;

  ThemeName: string = "";

  CurrentPagesAllotted: number;
  //Check Volume-Issue Already inprocess or Completed - Check by PlanID (0 - Still not IssueClosure)
  checkIssueClouse: number = 0;
  checkIssueAPIComplete: number = 0;
  showIssueContentBody: boolean = false;
  showIssueElements: boolean = true;
  JournalListAPI: string = "";
  VolumeIssueListAPI: string = "";
  IssueConfigAPI: string = "";
  IssueTypeListAPI: string = "";
  VolIssueList: string = "";
  ProjectPlanListAPI: string = "";
  ArticleListAPI: string = "";
  FrontandBackMatterListAPI: string = "";
  DownloadFileAPI: string = "";
  VolIssueWarning: string = "";
  showAddArticle: boolean = false;
  showAddDivider: boolean = false;
  UpdateIssueToArticle: string = "";
  IssueClosureAPI: string = "";
  UpdateIssueCorrectionAPI: string = "";
  IssueApproveAPI: string = "";

  AddIssueDetailsAPI: string = "";
  UpdateIssueActivityDateAPI: string = "";

  UplodIssueFilesAPI: string = "";
  DownloadIssueFileAPI: string = "";
  RemoveIssueFileAPI: string = "";

  SaveIssueLineupOrderApi: string;
  UpdateIssueRemarksApi: string;

  IssueMasterAPI: string = "";
  //Article Datatable load variables
  datasetList: any;
  dataTableList: any;

  datasetArt: any;
  dataTableArt: any;
  datasetIssArt: any;
  dataTableIssArt: any;

  IssueIdSelectWarning: string = "";
  ArticleAddSelectWarning: string = "";

  IssueClosureConfirmTitle: string = "";
  IssueClosureConfirmText: string = "";
  IssueClosureProcessTitle: string = "";
  IssueClosureProcessText: string = "";

  FrontMatter: boolean;
  BackMatter: boolean;
  FrontElementActions: boolean;
  BackElementActions: boolean;
  IssueByIDAPI: string;
    
}
